/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbRespCollectionsComponents_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespCollectionsModules_user$ref: FragmentReference;
export type SbRespCollectionsModules_user = {|
  +$fragmentRefs: SbRespCollectionsComponents_user$ref,
  +$refType: SbRespCollectionsModules_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespCollectionsModules_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespCollectionsComponents_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e1ddf31a066173dddc0b89b41bec86d3';
module.exports = node;
